import type { MeetingRoom } from "@/types/calendar";

export const MEETING_ROOMS: MeetingRoom[] = [
	{
		id: "5f-1",
		name: "5F-1",
		displayName: "5F-1",
		calendarUrl:
			"https://calendar.google.com/calendar/ical/c_188aojukm5b6chqmmnok0h6s3v8se%40resource.calendar.google.com/private-b1e35ba89c907cdf826a22c827764949/basic.ics",
		resourceEmail: "c_188aojukm5b6chqmmnok0h6s3v8se@resource.calendar.google.com",
		color: "#4285f4",
	},
	{
		id: "5f-2",
		name: "5F-2",
		displayName: "5F-2",
		calendarUrl:
			"https://calendar.google.com/calendar/ical/c_1884l28vqoje0ij4hjeipv86h7q0c%40resource.calendar.google.com/private-1069b36ce4b22568f889eeb25a149806/basic.ics",
		resourceEmail: "c_1884l28vqoje0ij4hjeipv86h7q0c@resource.calendar.google.com",
		color: "#0f9d58",
	},
	{
		id: "5f-3",
		name: "5F-3",
		displayName: "5F-3",
		calendarUrl:
			"https://calendar.google.com/calendar/ical/c_1886gqekq2ti2jf1licn4uo4ck9vo%40resource.calendar.google.com/private-048d9617b2a3ef958de8a4a997235834/basic.ics",
		resourceEmail: "c_1886gqekq2ti2jf1licn4uo4ck9vo@resource.calendar.google.com",
		color: "#f4b400",
	},
	{
		id: "5f-4",
		name: "5F-4",
		displayName: "5F-4",
		calendarUrl:
			"https://calendar.google.com/calendar/ical/c_1885pi5v4v0u0j68g68qu0nsq4k34%40resource.calendar.google.com/private-8bbca897f82b0babd51b1c5b6d3b8064/basic.ics",
		resourceEmail: "c_1885pi5v4v0u0j68g68qu0nsq4k34@resource.calendar.google.com",
		color: "#db4437",
	},
	{
		id: "5f-5",
		name: "5F-5",
		displayName: "5F-5",
		calendarUrl:
			"https://calendar.google.com/calendar/ical/c_1887c6rolg0o2jk7lvto0tug6a1kc%40resource.calendar.google.com/private-3dbff19de55c16fcb91a86a67134aa4a/basic.ics",
		resourceEmail: "c_1887c6rolg0o2jk7lvto0tug6a1kc@resource.calendar.google.com",
		color: "#ab47bc",
	},
];

export const CALENDAR_CONFIG = {
	startHour: 7, // 7 AM
	endHour: 22, // 10 PM
	hourHeight: 60, // pixels per hour
	refreshInterval: 1 * 60 * 1000, // 1 minute
	timeUpdateInterval: 30 * 1000, // 30 seconds
	timeZone: "Asia/Seoul",
};

export const BOOKING_CONFIG = {
	durationPresets: [15, 30, 45, 60, 90, 120] as const,
	defaultDurationMin: 30,
	maxDurationMin: 240,
	slotRoundingMin: 5,
};
